import userApi from '../../api/user';

const state = () => ({
    profile: null,
    paymentMethods: null
});

// getters
const getters = {
    profile(state) {
        return state.profile;
    },
    paymentMethods(state) {
        return state.paymentMethods;
    },
};

// actions
const actions = {
    loadProfile({commit, state, dispatch}) {
        commit('setIsLoading', true, {root: true});
        return userApi.me().then(data => {
            commit('setProfile', data.profile);
            return Promise.resolve(data.profile);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    updateProfile({commit, state, dispatch}, profile) {
        commit('setIsLoading', true, {root: true});
        return userApi.updateProfile(profile).then(response => {
            commit('setProfile', response.profile);
            return Promise.resolve(response.profile);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    deletePaymentMethod({commit, state, dispatch}, paymentMethod) {
        commit('setIsLoading', true, {root: true});
        return userApi.deletePaymentMethod(paymentMethod).then(response => {
            commit('removePaymentMethod', paymentMethod);
            return Promise.resolve(response.profile);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
    loadPaymentMethods({commit, state, dispatch}) {
        commit('setIsLoading', true, {root: true});
        return userApi.loadPaymentMethods().then(data => {
            commit('setPaymentMethods', data.payment_methods);
            return Promise.resolve(data.payment_methods);
        }).catch(error => {
            return Promise.reject(error);
        }).finally(() => {
            commit('setIsLoading', false, {root: true});
        });
    },
};

// mutations
const mutations = {
    setProfile(state, profile) {
        state.profile = profile;
    },
    setPaymentMethods(state, paymentMethods) {
        state.paymentMethods = paymentMethods;
    },
    removePaymentMethod(state, paymentMethod) {
        state.paymentMethods = _.filter(state.paymentMethods, pm => pm.id !== paymentMethod.id)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
